// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f415e81b","453":"f884173c","455":"aaf81655","977":"aa24753f"}[chunkId] + ".chunk.js";
};